export class MarcheAmelioration {
  constructor(public uuid: string) {}

  static adapt(item: any): MarcheAmelioration {
    return new MarcheAmelioration(item.uuid);
  }
}
